export default __webpack_public_path__ + "static/media/open.fca12534.jpg";